import React from 'react';
import _throttle from 'lodash/throttle';

import Module from '../components/module';
import Title from '../components/title';
import Paragraph from '../components/paragraph';
import SecondaryButton from '../components/secondary-button';
import Icon from '../components/icon';

import withDevice from '../components/withDevice';

class ImageText extends Module {
    state = {
        textBoxHeight: 0,
        textBoxHeight: 0,
    };

    textBoxRef = React.createRef();
    downloadBtnRef = React.createRef();

    resizeWithThrottle = _throttle(() =>
        this.setState({
            textBoxHeight: this.textBoxRef.current.clientHeight,
            downloadBtnHeight: this.downloadBtnRef?.current?.clientHeight,
        }),
    );

    componentDidMount = () => {
        window.addEventListener('resize', this.resizeWithThrottle);

        setTimeout(() => {
            this.setState({
                textBoxHeight: this.textBoxRef.current.clientHeight,
                downloadBtnHeight: this.downloadBtnRef?.current?.clientHeight,
            });
        }, 100);
    };

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.resizeWithThrottle);
    };

    render() {
        const { config, device } = this.props;
        const { textBoxHeight, downloadBtnHeight } = this.state;

        const {
            title,
            desc,
            button_text,
            button_url,
            button_type,
            attachment_url,
            attachment_name,
        } = config;
        const { src, srcset, alt } = { ...config.image_data };

        const isCentered = config.image_placement === 'center';
        const alignmentType = isCentered ? 'text-centered' : 'text-aside';
        const needReverse =
            config.image_placement === 'right' && device.isDesktop;

        const applyWrapperStyleIfDesktop = (style) =>
            !device.isMobile && !device.isTablet ? style : undefined;

        const downloadBtnAdditionalStyles = () => {
            const imageLeft = config.image_placement === 'left';

            if (!device.isDesktop) {
                return {
                    position: 'absolute',
                    bottom: 0,
                    [imageLeft ? 'left' : 'right']: '50%',
                    transform: `translate(${imageLeft ? '-50%' : '50%'}, ${
                        downloadBtnHeight * 0.4
                    }px)`,
                };
            }
        };

        const isDesktopAndHasDownloadBtn =
            device.isDesktop && !isCentered && button_type === 'download';

        return (
            <div className={applyWrapperStyleIfDesktop('-padded')}>
                <div className={applyWrapperStyleIfDesktop('-wrap')}>
                    <section
                        className={`
                            image-text
                            image-text--${alignmentType}
                            ${needReverse ? 'image-text--reverse' : ''}
                            ${
                                button_type === 'download'
                                    ? 'image-text--has-download-btn'
                                    : ''
                            }
                            
                        `}>
                        {!isCentered && (
                            <div
                                className={`
                                    image-text__offset
                                    image-text__offset--left
                                `}
                                style={{
                                    height: textBoxHeight,
                                    marginTop: isDesktopAndHasDownloadBtn
                                        ? 50
                                        : 0,
                                }}
                            />
                        )}
                        <img
                            className={`
                                image-text__image
                                image-text__image--${alignmentType}
                            `}
                            src={src}
                            srcSet={srcset}
                            alt={alt}
                            style={
                                device.isDesktop
                                    ? {
                                          height:
                                              textBoxHeight +
                                              (isDesktopAndHasDownloadBtn
                                                  ? 175
                                                  : 100),
                                      }
                                    : undefined
                            }
                        />
                        {(title || desc || button_text || button_url) && (
                            <div
                                className={`
                                    image-text__text__container
                                    image-text__text__container--${alignmentType}
                                `}
                                style={
                                    isCentered
                                        ? {
                                              minHeight: device.isDesktop
                                                  ? textBoxHeight - 30
                                                  : textBoxHeight + 15,
                                          }
                                        : undefined
                                }>
                                <div
                                    ref={this.textBoxRef}
                                    className={`
                                        image-text__text 
                                        image-text__text--${alignmentType}
                                        ${
                                            button_type === 'download'
                                                ? 'image-text__text--has-download-btn'
                                                : ''
                                        }
                                    `}>
                                    {title && (
                                        <Title
                                            className={`
                                                image-text__text__title
                                                image-text__text__title--${alignmentType}
                                            `}
                                            level={1}>
                                            {title}
                                        </Title>
                                    )}
                                    {desc && (
                                        <Paragraph
                                            className={`
                                                image-text__text__desc
                                                image-text__text__desc--${alignmentType}
                                                ${
                                                    button_type === 'download'
                                                        ? 'image-text__text__desc--has-download-btn'
                                                        : ''
                                                }
                                            `}
                                            size="large">
                                            {desc}
                                        </Paragraph>
                                    )}
                                    {(button_url || attachment_url) &&
                                        (button_type === 'download' ? (
                                            <a
                                                href={attachment_url}
                                                download
                                                style={{
                                                    textDecoration: 'none',
                                                }}>
                                                <div
                                                    ref={this.downloadBtnRef}
                                                    className={`
                                                        image-text__text__button__download
                                                        image-text__text__button__download--${config.image_placement}
                                                    `}
                                                    role="button"
                                                    style={downloadBtnAdditionalStyles()}>
                                                    <Icon
                                                        className="image-text__text__button__download__icon"
                                                        name="pdf"
                                                    />
                                                    {button_text}
                                                </div>
                                            </a>
                                        ) : (
                                            <SecondaryButton
                                                className="image-text__text__button__link"
                                                type="link"
                                                title={button_text}
                                                href={button_url}>
                                                {button_text}
                                            </SecondaryButton>
                                        ))}
                                </div>
                            </div>
                        )}
                        {!isCentered && (
                            <div
                                className={`
                                    image-text__offset
                                    image-text__offset--right
                                `}
                                style={{
                                    height: textBoxHeight,
                                    marginTop: isDesktopAndHasDownloadBtn
                                        ? 50
                                        : 0,
                                }}
                            />
                        )}
                    </section>
                </div>
            </div>
        );
    }
}

export default withDevice(ImageText);
